// Consultation/ConsultationRescheduleForm.tsx

import React, {useState} from "react";
import {useTheme} from "Theme/ThemeContext";
import {Message} from "Core/components/Message";
import {FCCC, FRCC} from "WideLayout/Layouts";
import {TextField} from "@mui/material";
import Button from "Core/components/elements/Button/Button";
import CircularProgress from "@mui/material/CircularProgress";
import PsychologistConsultationDateTimePicker from "../Psychologist/PsychologistConsultationDateTimePicker";
import {IConsultation} from "../../Types/psychology/consultation";

interface ConsultationRescheduleFormProps {
    consultation: IConsultation;
    onConfirm: (slot: string, reason: string) => void;
    onCancel: () => void;
    loading: boolean;
    cls?: string;
}

const ConsultationRescheduleForm: React.FC<ConsultationRescheduleFormProps> = (
    {
        consultation,
        onConfirm,
        onCancel,
        loading,
        cls,
    }) => {
    const {plt} = useTheme();
    const [selectedSlot, setSelectedSlot] = useState<string | null>(null);
    const [rescheduleReason, setRescheduleReason] = useState<string>('');

    const handleSlotSelect = (slot: string) => {
        setSelectedSlot(slot);
    };

    const handleConfirmClick = () => {
        if (!selectedSlot) {
            Message.error('Пожалуйста, выберите слот.');
            return;
        }
        onConfirm(selectedSlot, rescheduleReason);
    };

    return (
        <FCCC g={1} cls={cls} ml={2} pos={'relative'}>
            {/* Компонент выбора слота */}
            {consultation.psychologists[0].psychologist &&
                <PsychologistConsultationDateTimePicker
                    className="reschedule-slot-picker"
                    psychologistId={consultation.psychologists[0].psychologist.id}
                    duration={consultation.config.duration}
                    onConfirmSlot={handleSlotSelect}
                />}

            {/* Поле для ввода причины переноса (необязательно) */}
            <TextField
                label="Причина (необязательно)"
                value={rescheduleReason}
                onChange={(e) => setRescheduleReason(e.target.value)}
                multiline
                fullWidth
            />

            {/* Кнопки подтверждения и отмены */}
            <FRCC g={1} wrap>
                <Button
                    onClick={handleConfirmClick}
                    className={'fw-bold'}
                    sx={{color: '#fff'}}
                    color={plt.colors.secondary.light}
                    variant={'contained'}
                    disabled={loading || !selectedSlot}
                >
                    Подтвердить
                </Button>
                <Button
                    onClick={onCancel}
                    variant={'contained'}
                    sx={{color: plt.text.primary60}}
                    color={plt.colors.secondary.lighter}
                    disabled={loading}
                >
                    Отмена
                </Button>
            </FRCC>

            {/* Индикатор загрузки */}
            {loading && (
                <FCCC
                    pos={'absolute'}
                    className={'backdrop-blur-10'}
                    top={0}
                    left={0}
                    zIndex={22231}
                    rounded={3}
                    w={'100%'}
                    h={'100%'}
                >
                    <CircularProgress sx={{marginBottom: '20px'}} size={'3rem'}/>
                </FCCC>
            )}
        </FCCC>
    );
};

export default ConsultationRescheduleForm;
